
import { Component, Emit, Inject, Vue, Watch } from 'vue-property-decorator';
import RegistroPontoHeader from './RegistroPontoHeader.vue';
import RegistroPontoDisplay from './RegistroPontoDisplay.vue';
import RegistroPontoKeypad from './RegistroPontoKeypad.vue';
import RegistroPontoNovo from '../RegistroPontoNovo.vue';
import type { VinculoPontoUnidade } from '../types-registro-ponto';
import PopupController from '@/assets/ts/controller/PopupController';
import OfflineController from '@/assets/ts/controller/OfflineController';
import IntervalController from '@/assets/ts/controller/IntervalController';
import Util from '@tekvue/assets/utils/Util';
import User from '@/assets/ts/interfaces/User';
import Estrutura from '@tekvue/assets/interfaces/Estrutura';
import { Getter, Mutation } from 'vuex-class';
import Constants from '@/assets/ts/configuration/Constants';
import OperadorController from '@/assets/ts/controller/OperadorController';
import registroPontoMessages from '@/assets/ts/messages/registroPontoMessages';

@Component({
  components: {
    RegistroPontoHeader,
    RegistroPontoDisplay,
    RegistroPontoKeypad,
  },
})
export default class RegistroPontoMain extends Vue {
  //#region [ INJECTED ]
  @Inject() findVinculo!: typeof RegistroPontoNovo.prototype.findVinculo;
  //#endregion



  //#region [ EVENTS ]
  @Emit('rec-facial-btn-clicked')
  emitRecFacialBtnClick(): void {}

  @Emit('qr-code-btn-clicked')
  emitQrCodeBtnClick(): void {}

  @Emit('ponto-btn-clicked')
  emitPontoBtnClicked(): VinculoPontoUnidade {
    return this.currentVinculo;
  }
  //#endregion



  //#region [ DATA ]
  pin: string = '';
  error?: string = null;
  errorTimeout?: number = null;
  setRegistroComAlmoco: boolean = false;
  lastClockInQRCodeScanned: boolean = false;
  fullScreenActivated: boolean = false;
  //#endregion



  //#region [ STORE ]
  get estruturaGerencialAtual(): Estrutura {
    return this.$store.getters.estruturaGerencialAtual;
  }

  @Getter('user')
  user!: User;
  //#endregion



  //#region [ COMPUTED ]
  get unidade(): string {
    return this.estruturaGerencialAtual ? this.estruturaGerencialAtual.NMESTRUTURA : '-';
  }

  get registroPontoDisplay(): RegistroPontoDisplay {
    return this.$refs.registroPontoDisplay as RegistroPontoDisplay;
  }

  get currentVinculo(): VinculoPontoUnidade | null {
    return this.findVinculo(this.pin) || null;
  }

  get name(): string | null {
    return this.currentVinculo ? this.currentVinculo.NMVINCULOM : null;
  }
  //#endregion



  //#region [ WATCHERS ]
  @Watch('pin')
  private pinOnChange(): void {
    this.clearError();
  }
  //#endregion



  //#region [ LIFECYCLE ]
  async mounted(): Promise<void> {
    Util.addFullScreenChangeListener(this.updateFullScreenFlag);
  }
  //#endregion



  //#region [ METHODS ]
  addDigit(n: string): void {
    if (this.pin.length < 11) {
      this.pin += n;
    }
  }

  removeDigit(): void {
    this.pin = this.pin.slice(0, -1);
  }

  handlePontoBtnClick(): void {
    if (this.pin.length === 0) {
      this.registroPontoDisplay.blinkDashes();
      this.showError('Digite seu código!', 1000);
    } else if (!this.currentVinculo) {
      this.showError(registroPontoMessages.vinculoNotFound, 1000);
    } else {
      this.emitPontoBtnClicked();
    }
  }

  showError(errorMessage: string, duration: number): void {
    this.clearError();
    this.error = errorMessage;
    this.errorTimeout = window.setTimeout(this.clearError, duration);
  }

  clearError(): void {
    this.error = null;

    if (this.errorTimeout) {
      clearTimeout(this.errorTimeout);
      this.errorTimeout = null;
    }
  }

  clearPin(): void {
    this.pin = '';
  }

  private leaveScreen() {
    if (this.user.idpgrestringeregist && !OfflineController.checkIsOfflineAbsolute()) {
      PopupController.openConfirmPasswordPopUp();
      return;
    }

    IntervalController.cancelRPUIntervalReload();
    this.$router.push('/');
  }

  toggleFullScreen() {
    const el = document.querySelector('.v-application');
    if (!el) {
      return;
    }

    if (this.updateFullScreenFlag()) {
      Util.requestFullScreenClose(el);
    } else {
      Util.requestFullScreen(el);
    }
  }

  updateFullScreenFlag(): boolean {
    this.fullScreenActivated = !Util.isInFullScreen();
    return this.fullScreenActivated;
  }
}
